<template>
  <div
    :class="`headerBox ${isCollapsed ? 'collapsed' : 'uncollapsed'}`"
    @click="clicked(items)"
    @mouseover="isCollapsed = false"
    @mouseleave="isCollapsed = true"
  >
    <div class="headerBox-wrapper" :style="cssVars">
      <div class="headerBox-wrapper--content">
        <div class="icon-left">
          <span
            style="padding-right: 5px; font-size: 24px"
            :class="leftIcon.class"
            :style="leftIcon.styles"
          ></span>
        </div>

        <div class="middle-content">
          <div v-if="isCollapsed" class="row-item">
            {{ collapsedTitle }}
          </div>

          <div
            class="middle-content-item"
            v-else
            v-for="(item, index) in uncollapsedDetails"
            v-bind:key="index"
          >
            <div
              class="middle-content-item-row"
              v-if="item.value.length && Array.isArray(item.value)"
            >
              <span class="row-item row-left" :style="{ color: labelColor }"
                >{{ item.key }}:</span
              >
              <span class="row-item row-right"
                ><span
                  class="row-item-sub--item"
                  v-for="(element, i) in item.value"
                  v-bind:key="i"
                >
                  {{ element }}
                </span></span
              >
            </div>
          </div>
        </div>

        <div v-if="!isCollapsed" class="icon-right">
          <span
            style="font-size: 24px"
            :class="rightIcon.class + ' styleIcon'"
            :style="rightIcon.styles"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerInfoBox",
  props: {
    collapsed: {
      type: Boolean,
      default: true,
    },
    labelColor: {
      type: String,
      default: "#77b7fc",
    },
    leftIcon: {
      type: Object,
      default: () => {
        return {
          class: "",
          styles: "color: #aadc14",
        };
      },
    },
    rightIcon: {
      type: Object,
      default: () => {
        return {
          class: "",
          color: "#aadc14",
        };
      },
    },
    items: {
      type: Array,
      default: null,
    },
    heightSize: {
      type: String,
      default: "23px",
    },
  },
  data() {
    return {
      isCollapsed: this.collapsed,
      uncollapsedDetails: null,
    };
  },
  computed: {
    cssVars() {
      return {
        "--icon-edit-color": this.rightIcon.color ?? "#aadc14",
      };
    },
    collapsedTitle() {
      const routesToMatch = ["fileProcessing", "FileProcessingDetails"];

      if (routesToMatch.includes(this.$route.name)) {
        const targetClient = this.items[0].value[0];
        if (this.hasAccessToHighestLevel(targetClient)) {
          const copy = [...this.items];
          const result = [copy.shift()];
          this.updateCardUncollapsedDetails(result);
          return this.getHirarchiesLine(result);
        } else {
          this.redirectToNoScopesPage(401);
          return this.getHirarchiesLine(this.items);
        }
      } else {
        this.updateCardUncollapsedDetails(this.items);
        return this.getHirarchiesLine(this.items);
      }
    },
  },
  methods: {
    updateCardUncollapsedDetails(data) {
      this.uncollapsedDetails = data;
    },
    hasAccessToHighestLevel(client) {
      return (
        this.$jwt.scope.includes("ALL") ||
        this.$jwt.scope.includes(`ALL.${client}`)
      );
    },
    redirectToNoScopesPage(code = 499) {
      this.$router.replace({
        name: "error",
        params: { code: code },
      });
    },
    getHirarchiesLine(data) {
      if (data) {
        let result = data
          .filter((w) => w.value.length)
          .map((elem) => ({
            key: elem.key,
            value: elem.value.join(", "),
          }))
          .map((x) => x.value)
          .join(" > ");
        return result;
      } else return "";
    },
    clicked: function (item) {
      this.$emit("clickEvent", item);
    },
  },
};
</script>
:

<style scoped>
.headerBox {
  background-color: #030f40;
  transition: width 0.2s, height 0.2s;
  z-index: 100000;
  position: relative;
  cursor: pointer;
}

.headerBox.collapsed {
  transition: width 0.5s, height 0.5s;
}

.headerBox-wrapper {
  border-radius: 5px;
  border: 1px solid #ffffff;
  position: relative;
  min-height: 50px;
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.headerBox.uncollapsed > .headerBox-wrapper {
  position: absolute;
  background: inherit;
  top: 0;
  left: 0;
}

.headerBox > .headerBox-wrapper > .headerBox-wrapper--content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  padding: 5px 10px;
  width: 100%;
}

.headerBox
  > .headerBox-wrapper
  > .headerBox-wrapper--content
  > .middle-content {
  flex: 1;
}

.middle-content > .middle-content-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.middle-content > .middle-content-item > .middle-content-item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-basis: 0;
  flex-grow: 1;
}

.middle-content > .row-item,
.middle-content > .middle-content-item > .middle-content-item-row > .row-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-basis: 0;
  flex-grow: 1;
  text-transform: uppercase;
}

.row-item-sub--item {
  display: block;
}

.styleIcon::before {
  font-size: 24px;
  color: var(--icon-edit-color) !important;
  cursor: pointer;
}

li {
  list-style-type: none;
}
</style>
